<div class="otp-input" [ngClass]="{ 'otp-input--disabled': disabled }" [formGroup]="form">
  <input
    class="otp-input__item"
    type="text"
    autocomplete="one-time-code"
    inputmode="numeric"
    pattern="[0-9]"
    [formControlName]="'firstNumber'"
    autofocus
    (focus)="focus($event)"
    (input)="inputKey($event, 'firstNumber')"
    (paste)="paste($event)"
    (keyup)="keyup($event)"
    (keydown)="keydown($event)"
    (click)="focus($event)"
  />
  <input class="otp-input__item" type="text" inputmode="numeric" pattern="[0-9]" [formControlName]="'secondNumber'" (focus)="focus($event)" (input)="inputKey($event, 'secondNumber')" (paste)="paste($event)" (keyup)="keyup($event)" (keydown)="keydown($event)" (click)="focus($event)" />
  <input class="otp-input__item" type="text" inputmode="numeric" pattern="[0-9]" [formControlName]="'thirdNumber'" (focus)="focus($event)" (input)="inputKey($event, 'thirdNumber')" (paste)="paste($event)" (keyup)="keyup($event)" (keydown)="keydown($event)" (click)="focus($event)" />
  <input class="otp-input__item" type="text" inputmode="numeric" pattern="[0-9]" [formControlName]="'fourthNumber'" (focus)="focus($event)" (input)="inputKey($event, 'fourthNumber')" (paste)="paste($event)" (keyup)="keyup($event)" (keydown)="keydown($event)" (click)="focus($event)" />
</div>
